export const SI_FORGOT_PWD_LINK_CLICK =
  'SignIn.Web-App.SignUp-Modal.Forgot-Password-Link.click';
export const SI_NEED_ACCOUNT_CLICK =
  'SignIn.Web-App.SignUp-Modal.Need-Account-Link.click';
export const SI_SEND_RESET_PWD_CLICK =
  'SignIn.Web-App.SignUp-Modal.Send-Reset-Password-Link.click';
export const SI_RETURN_TO_LOGIN_CLICK =
  'SignIn.Web-App.SignUp-Modal.Return-To-Login.click';
